import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import PropertyBox from './property-box';
import { CandidateStatusContent, CandidateStatusCtas } from './styles';
const ApplicationCandidateStatus = ({ properties, programName, programId, }) => {
    const { t } = useTranslations();
    const handleLearnMore = () => {
        window.open(`/funding-explorer/${programId}#grant_favorites`, '_blank');
    };
    return (_jsxs(CandidateStatusCtas, { children: [_jsxs(Typography, { elementTheme: "subtitle2", children: [t('gin_steps|favouredCandidateFor'), " ", programName] }), properties.map((property) => (_jsx(PropertyBox, { propertyItem: property }, property.item_id))), _jsx(CandidateStatusContent, { onClick: handleLearnMore, children: _jsx(Typography, { elementTheme: "body2", children: t('application_single|learnMore') }) })] }));
};
export default ApplicationCandidateStatus;
